import { Text } from 'shared/components/Text/Text'
import { midGray, white } from 'shared/theme/colors'
import styled from 'styled-components'

import { LoadTag, LoadTagNameDisplay, LoadTagNameDisplaySortOrder } from '../../models/load'

interface LoadTagItemProps {
  loadTag: LoadTag
}

function LoadTagItem({ loadTag }: LoadTagItemProps) {
  return (
    <LoadTagPill>
      <LoadTagText variant="label3" fontColor={white}>
        {LoadTagNameDisplay[loadTag.name]}
      </LoadTagText>
    </LoadTagPill>
  )
}

interface LoadTagItemMoreProps {
  num: number
}

function LoadTagItemMore({ num }: LoadTagItemMoreProps) {
  return (
    <LoadTagPill $rounded>
      <LoadTagText variant="label3" fontColor={white}>
        +{num}
      </LoadTagText>
    </LoadTagPill>
  )
}

interface LoadTagsProps {
  loadTags: LoadTag[]
  hideRecommendedTag?: boolean
  limit?: number
}

export function LoadTags({ loadTags, hideRecommendedTag, limit = 2 }: LoadTagsProps) {
  const filteredLoadTags = loadTags.filter(
    (l) => l.value && (hideRecommendedTag ? l.name !== 'recommended' : true)
  )

  return (
    <LoadTagsContainer>
      {filteredLoadTags
        .sort((a, b) => LoadTagNameDisplaySortOrder[a.name] - LoadTagNameDisplaySortOrder[b.name])
        .slice(0, limit)
        .map((load_tag) => (
          <LoadTagItem key={load_tag.name} loadTag={load_tag} />
        ))}
      {filteredLoadTags.length > limit && <LoadTagItemMore num={filteredLoadTags.length - 2} />}
    </LoadTagsContainer>
  )
}

const LoadTagPill = styled.div<{ $rounded?: boolean }>`
  display: inline-flex;
  height: 20px;
  ${({ $rounded }) => $rounded && 'width: 20px'};
  padding: ${({ $rounded }) => ($rounded ? '0' : '1px 8px')};
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: ${({ $rounded }) => ($rounded ? '10px' : '3px')};
  background: ${midGray};
`

const LoadTagText = styled(Text)`
  font-size: 12px;
  font-weight: 600;
`

const LoadTagsContainer = styled.div`
  justify-self: flex-end;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`
